import { registerSW } from './sw-register';
import moment from 'jalali-moment';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import {
  AppContextProvider,
  UserContextProvider,
  SelfContextProvider,
  MessageContextProvider,
  UniversityContextProvider,
  CurrentReservesContextProvider
} from '@/context';
import './reset.scss';
import App from './App.tsx';
import 'antd/dist/reset.css';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/effect-cards';
import './index.scss';
import './styles/typography.css';
import './styles/announcement-rich-text.css';
import envConfig from './configs/env.ts';

// Only register service worker in production to avoid infinite reload issues in development
if (envConfig.isProduction) {
  registerSW();
}

console.log('isProduction', envConfig.isProduction);

moment.locale('fa');

import { useEffect, useState } from 'react';
import React from 'react';

function SWUpdatePrompt() {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      const customEvent = e as CustomEvent<{ registration: ServiceWorkerRegistration }>;
      setRegistration(customEvent.detail.registration);
    };
    window.addEventListener('sw-update-available', handler as EventListener);
    return () => {
      window.removeEventListener('sw-update-available', handler as EventListener);
    };
  }, []);

  if (!registration) return null;

  const onUpdateClick = () => {
    if (updating) return;
    setUpdating(true);
    const waiting = registration.waiting;
    if (waiting) {
      // Ask the waiting service worker to skip waiting and become active
      waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  // Simple inline styles to avoid external CSS changes
  const containerStyle: React.CSSProperties = {
    position: 'fixed',
    left: 16,
    right: 16,
    bottom: 16,
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#1f2937',
    color: '#fff',
    padding: '12px 16px',
    borderRadius: 8,
    boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
    direction: 'rtl',
  };

  const buttonStyle: React.CSSProperties = {
    background: '#10b981',
    color: '#0b1f17',
    border: 'none',
    borderRadius: 6,
    padding: '8px 12px',
    cursor: 'pointer',
    fontWeight: 600
  };

  return (
    <div style={containerStyle} role="status" aria-live="polite">
      <span>نسخه جدید برنامه آماده است.</span>
      <button onClick={onUpdateClick} style={buttonStyle} disabled={updating}>
        {updating ? 'در حال به‌روزرسانی…' : 'به‌روزرسانی'}
      </button>
    </div>
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      gcTime: 0,
      refetchOnWindowFocus: false,
    }
  }
});

const root = document.getElementById('root');
ReactDOM.createRoot(root!).render(
  <QueryClientProvider client={queryClient}>
    <UniversityContextProvider>
      <AppContextProvider>
        <UserContextProvider>
          <SelfContextProvider>
            <MessageContextProvider>
              <CurrentReservesContextProvider>
                <App />
                <SWUpdatePrompt />
              </CurrentReservesContextProvider>
            </MessageContextProvider>
          </SelfContextProvider>
        </UserContextProvider>
      </AppContextProvider>
    </UniversityContextProvider>
  </QueryClientProvider>
);
